import React from 'react'
import ReactDOM from 'react-dom/client'
import './css/index.css'
import App from './App.jsx'
import { createRoot } from 'react-dom/client'
import reportWebVitals from './js/reportWebVitals.jsx'
import 'bootstrap/dist/css/bootstrap.min.css'

const root = createRoot(document.getElementById('root'))
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
